import {DateTime} from "luxon";

const state = {
    rentals: {
        journeyDate: DateTime.now(),
        duration: null,
        priceRange: [0, 100],
        // bikeTypes: [],
        keyword: '',
        location: null
    },
    products: {
        priceRange: [0, 100],
        tags: [],
        conditions: [],
        types: [],
        eScooters: ['e-scooter', 'escooter', 'e scooter']
    },
}

const actions = {

}

const mutations = {
    SET_JOURNEY_DATE: (state, value) => {
        state.rentals.journeyDate = value;
    },
    SET_DURATION: (state, value) => {
        state.rentals.duration = value;
    },
    SET_RENTAL_PRICE_RANGE: (state, value) => {
        state.rentals.priceRange = value;
    },
    SET_PRODUCT_PRICE_RANGE: (state, value) => {
        state.products.priceRange = value;
    },
    SET_PRODUCT_TAGS: (state, value) => {
        state.products.tags = value;
    },
    SET_PRODUCT_CONDITIONS: (state, value) => {
        state.products.conditions = value;
    },
    SET_PRODUCT_TYPES: (state, value) => {
        state.products.types = value;
    },
    SET_PRODUCT_FILTERS: (state, value) => {
        state.products.types = value['types'];
        state.products.conditions = value['conditions'];
        state.products.tags = value['tags'];
    },
    // SET_BIKE_TYPES: (state, value) => {
    //     state.rentals.bikeTypes = value;
    // },
    SET_KEYWORD: (state, value) => {
        state.rentals.keyword = value;
    },
    SET_RENT_LOCATION: (state, value) => {
        state.rentals.location = value;
    },
}

const getters = {
    journeyDate: (state) => state.rentals.journeyDate,
    duration: (state) => state.rentals.duration,
    rentalPriceRange: (state) => state.rentals.priceRange,
    productPriceRange: (state) => state.products.priceRange,
    productTags: (state) => state.products.tags,
    productConditions: (state) => state.products.conditions,
    productTypes: (state) => state.products.types,
    productEScooter: (state) => state.products.eScooters,
    // bikeTypes: (state) => state.rentals.bikeTypes,
    keyword: (state) => state.rentals.keyword,
    rentLocation: (state) => state.rentals.location,
}

export default {
    strict: true,
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
